import React from "react";
import Index from "../src/Index";

const IndexPage = () => <Index />;

export default IndexPage;
